import styled from 'styled-components'

export const Box = styled.div`
  position: relative;
  display: inline-block;
`

export const Menu = styled.div`
  box-shadow: 0 7px 21px 0 rgba(0, 0, 0, 0.11);
  border-radius: 8px;
  background: var(--theme-colors-global-general-main);
  font: var(--theme-typography-bodyM-regular);
  overflow: hidden;
  padding-bottom: 8px;
  padding-top: 8px;
`

export const ButtonWrapper = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-block;
`
